import { createSlice } from "@reduxjs/toolkit";

import { completeTask, createTask, getTasks } from "@/api/task/thunk";
import { TaskState } from "@/types/store";
import { Task } from "@/types/task";

export const initialState: TaskState = {
  ongoingTasks: {
    tasks: [],
    loading: false,
    error: null,
    page: 1,
    hasNextPage: true,
  },
  completedTasks: {
    tasks: [],
    loading: false,
    error: null,
    page: 1,
    hasNextPage: true,
  },
  tab: "ongoing",
};

export const taskSlice = createSlice({
  name: "taskSlice",
  initialState,
  reducers: {
    setTab: (state, action) => {
      state.tab = action.payload;
    },
    setOngoingPage: (state, action) => {
      state.ongoingTasks.page = action.payload;
    },
    setCompletedPage: (state, action) => {
      state.completedTasks.page = action.payload;
    },
    clearTaskData: (state) => {
      Object.assign(state, initialState);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTasks.pending, (state, action) => {
        if (action.meta.arg.completed) {
          state.completedTasks.loading = true;
        } else {
          state.ongoingTasks.loading = true;
        }
      })
      .addCase(getTasks.fulfilled, (state, action) => {
        if (action.meta.arg.completed) {
          state.completedTasks.tasks = [
            ...state.completedTasks.tasks,
            ...action.payload.tasks.filter(
              (newTask: Task) =>
                !state.completedTasks.tasks.some(
                  (existingTask) => existingTask.id === newTask.id
                )
            ),
          ];
        } else {
          state.ongoingTasks.tasks = [
            ...state.ongoingTasks.tasks,
            ...action.payload.tasks.filter(
              (newTask: Task) =>
                !state.ongoingTasks.tasks.some(
                  (existingTask) => existingTask.id === newTask.id
                )
            ),
          ];
        }

        if (action.meta.arg.completed) {
          state.completedTasks.loading = false;
        } else {
          state.ongoingTasks.loading = false;
        }
        if (action.meta.arg.completed) {
          state.completedTasks.hasNextPage = action.payload.hasNextPage;
        } else {
          state.ongoingTasks.hasNextPage = action.payload.hasNextPage;
        }
      })
      .addCase(getTasks.rejected, (state, action) => {
        if (action.meta.arg.completed) {
          state.completedTasks.loading = false;
          state.completedTasks.error = action.payload as string;
        } else {
          state.ongoingTasks.loading = false;
          state.ongoingTasks.error = action.payload as string;
        }
      })
      .addCase(completeTask.fulfilled, (state, action) => {
        if (action.meta.arg.completed) {
          state.ongoingTasks.tasks = state.ongoingTasks.tasks.filter(
            (task) => task.id !== action.payload.id
          );
          state.completedTasks.tasks = [
            action.payload,
            ...state.completedTasks.tasks,
          ];
        } else {
          state.completedTasks.tasks = state.completedTasks.tasks.filter(
            (task) => task.id !== action.payload.id
          );
          state.ongoingTasks.tasks = [
            action.payload,
            ...state.ongoingTasks.tasks,
          ];
        }
      })
      .addCase(completeTask.rejected, (state, action) => {
        if (action.meta.arg.completed) {
          state.completedTasks.error = action.payload as string;
        } else {
          state.ongoingTasks.error = action.payload as string;
        }
      })
      .addCase(createTask.fulfilled, (state, action) => {
        state.ongoingTasks.tasks = [
          action.payload,
          ...state.ongoingTasks.tasks,
        ];
      })
      .addCase(createTask.rejected, (state, action) => {
        state.ongoingTasks.error = action.payload as string;
      });
  },
});

export const { setTab, setOngoingPage, setCompletedPage, clearTaskData } =
  taskSlice.actions;
export default taskSlice.reducer;
